import { render, staticRenderFns } from "./DailyClubEvent.vue?vue&type=template&id=784e86d4&scoped=true&"
import script from "./DailyClubEvent.vue?vue&type=script&lang=js&"
export * from "./DailyClubEvent.vue?vue&type=script&lang=js&"
import style0 from "./DailyClubEvent.vue?vue&type=style&index=0&id=784e86d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784e86d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
